export default __webpack_public_path__ + "static/media/bookVideoNew.2d4e04c1.mp4";